export default "__VITE_ASSET__ZrD3D77m__"